<ion-button class="app-btn" shape="round" fill="outline"
  [routerLink]="exitRouterLink"
  [routerLinkActive]="exitRouterLinkActive"
  [replaceUrl]="replaceUrl"
  [queryParamsHandling]="queryParamsHandling">
  {{'Exit'|translate}}
</ion-button>